<template>
  <div>
    <div v-if="!ready">
      <blank></blank>
    </div>
    <div v-else>
      <b-card>
        <h1>Challenge</h1>
        <p>
          Challenge a card token from the marketplace. If the card value does
          not match it's asserted value, the challenger wins the collateral
        </p>
        <b-form-input
          v-model="tokenId"
          placeholder="tokenId"
          type="number"
          label="TokenId"
        ></b-form-input>
        <div class="mt-2 text-right">
          <br />
          <b-button :disabled="!tokenId || loading" @click="challenge()">
            <b-spinner label="Spinning" small v-if="loading"></b-spinner>
              {{
            tokenId && from[0]
              ? "Challenge token: " + tokenId + " from " + from[0]
              : "Challenge"
          }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import Blank from "@/components/Blank.vue";
export default {
  components: { Blank },
  data() {
    return {
      tokenId: null,
      loading: false,
    };
  },
  computed: {
    ready() {
      return this.$store.state.ethereum.ready;
    },
    from() {
      return this.$store.state.ethereum.profile || {};
    },
  },
  methods: {
    challenge() {
      this.loading = true;
      this.$store
        .dispatch("ethereum/challenge", { tokenId: this.tokenId })
        .then((data) => {
            console.log("Challenge: ", JSON.stringify(data))
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>Blank